import { Provider } from "react-redux";
import "./App.css";
import "./DesignConfig.css";
import store from "./redux/store";
import AppRoutes from "./components/globals/AppRoutes";
import DesignPhaseUtils from "./components/specials/DesignPhaseUtils";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import FetchLoader from "./components/specials/FetchLoader";
import { useEffect } from "react";
function App() {



  return (
    <>
      <Provider store={store}>
        <AppRoutes />
        {/* remove design utils  */}
        {/* <DesignPhaseUtils /> */}
        <ToastContainer />
        <FetchLoader/>
      </Provider>
    </>
  );
}

export default App;
